import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { Oval as Loader } from "react-loader-spinner";
import './confirm-email.css';
import HeaderSection from "../../../../components/layout/header";
import { useNavigation } from "../../../../shared/utils/useNavigation";
import { verifyConfirmToken, verifyEmail } from "../../../../shared/actions/authActions";
import { showError } from "../../../../shared/utils/swalHandler";

const MESSAGES = {
  invalidLink: 'Invalid link. Please use the link from your verification email.',
  expired: 'This verification link has expired. Please request a new one.',
  alreadyVerified: 'Your email address has already been verified. This link is no longer needed.',
  invalidLinkShort: 'Invalid link.',
};

const STATUS = {
  loading: 'loading',
  invalid: 'invalid',
  expired: 'expired',
  alreadyVerified: 'already_verified',
  success: 'success',
};

const ConfirmEmail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigation();
  const { userId } = useParams();
  const [status, setStatus] = useState(STATUS.loading);
  const [message, setMessage] = useState(null);
  const [role, setRole] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (!token || !userId) {
      setStatus(STATUS.invalid);
      setMessage(MESSAGES.invalidLink);
      return;
    }

    const confirmAccount = async () => {
      try {
        const tokenCheck = await dispatch(verifyConfirmToken(userId, token));

        if (!tokenCheck.valid) {
          const isExpired = tokenCheck.expired === true;
          const isAlreadyVerified = tokenCheck.alreadyVerified === true;
          setMessage(tokenCheck.message || (isExpired ? MESSAGES.expired : MESSAGES.invalidLinkShort));
          if (tokenCheck.rol !== undefined) setRole(tokenCheck.rol);
          setStatus(isAlreadyVerified ? STATUS.alreadyVerified : (isExpired ? STATUS.expired : STATUS.invalid));
          if (isExpired) {
            await showError(
              'Verification Link Expired',
              'This email verification link has expired. Please contact support to complete your account verification.'
            );
          }
          return;
        }

        const result = await dispatch(verifyEmail(token));
        if (result.success) {
          setRole(tokenCheck.rol ?? result.data?.rol);
          setMessage(result.message);
          setStatus(STATUS.success);
        } else {
          setStatus(STATUS.invalid);
          setMessage(result.error || MESSAGES.invalidLinkShort);
        }
      } catch (err) {
        setStatus(STATUS.invalid);
        setMessage(err?.message || MESSAGES.invalidLinkShort);
      }
    };

    confirmAccount();
  }, [dispatch, userId]);

  const handleLogin = () => {
    navigate.toLogin();
  };

  const handleResendEmail = () => {
    navigate.toResendVerification();
  };

  return (
    <div className="modern-confirm-email-screen">
      <HeaderSection
        type="image"
        hideBackButton={true}
      />

      <main className="modern-confirm-email-main">
        <div className="modern-confirm-email-bg-effects">
          <div className="modern-confirm-email-bg-gradient"></div>
          <div className="modern-confirm-email-bg-blur-1"></div>
          <div className="modern-confirm-email-bg-blur-2"></div>
        </div>

        <div className="modern-confirm-email-container">
          <div className="modern-confirm-email-welcome">
            <h1 className="modern-confirm-email-welcome-title">
              {status === STATUS.loading && 'Verifying Email'}
              {status === STATUS.invalid && 'Verification Failed'}
              {status === STATUS.expired && 'Verification Link Expired'}
              {status === STATUS.alreadyVerified && 'Email Already Verified'}
              {status === STATUS.success && 'Email Verified'}
            </h1>
            <p className="modern-confirm-email-welcome-subtitle">
              {status === STATUS.loading && 'Please wait while we confirm your account'}
              {(status === STATUS.invalid || status === STATUS.expired) && (message || (status === STATUS.expired ? MESSAGES.expired : 'Something went wrong.'))}
              {status === STATUS.alreadyVerified && (message || MESSAGES.alreadyVerified)}
              {status === STATUS.success && (role === 2 ? 'This is where things get juicy🍑💦' : "You're in hottie 🔥")}
            </p>
          </div>

          <div className="modern-confirm-email-content-container mt-4">
            <div className="modern-confirm-email-content-wrapper">
              {status === STATUS.loading && (
                <div className="modern-confirm-email-loading">
                  <div className="modern-confirm-email-spinner">
                    <Loader type="Oval" color="#f534bf" height={60} width={60} />
                  </div>
                </div>
              )}

              {(status === STATUS.invalid || status === STATUS.expired) && (
                <div className="modern-confirm-email-error">
                  <p className="modern-confirm-email-error-text">
                    {status === STATUS.expired
                      ? 'Request a new verification link and check your inbox to verify your email.'
                      : "You're in, hottie 😈 Log in to Juicy House and start turning your content into cash. Let's make it juicy 🍑💦"}
                  </p>
                  <div className="modern-confirm-email-actions">
                    <button
                      className={`modern-confirm-email-resend-btn${status === STATUS.expired ? ' modern-confirm-email-resend-btn-primary' : ''}`}
                      onClick={handleResendEmail}
                    >
                      <i className="fas fa-paper-plane"></i>
                      <span>{status === STATUS.expired ? 'Request new link' : 'Resend Email'}</span>
                    </button>
                    <button className="modern-confirm-email-login-btn" onClick={handleLogin}>
                      <i className="fas fa-right-to-bracket"></i>
                      <span>Go to Login</span>
                    </button>
                  </div>
                </div>
              )}

              {status === STATUS.alreadyVerified && (
                <div className="modern-confirm-email-success">
                  <button className="modern-confirm-email-continue-btn" onClick={handleLogin}>
                    <span>Go to Login</span>
                    <div className="modern-confirm-email-btn-shine"></div>
                  </button>
                </div>
              )}

              {status === STATUS.success && (
                <div className="modern-confirm-email-success">
                  <p className="modern-confirm-email-success-text">
                    {role === 2
                      ? 'Log in to explore exclusive content, send private messages, and enjoy 1-on-1 voice and video calls with creators.'
                      : "Log in and start turning your content into cash. Let's make it juicy!"}
                  </p>
                  <button className="modern-confirm-email-continue-btn" onClick={handleLogin}>
                    <span>Continue</span>
                    <div className="modern-confirm-email-btn-shine"></div>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ConfirmEmail;
